// 機房（plan SPEC #kinio-station-seat-site-share）：我能查的機房管理站與它的可分享工具。
import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { useScope } from '../../lib/scope';
import { siteApi, siteStations, type SiteStation, type SiteTool } from '../../lib/siteRoom';

export interface SiteRoomStation extends SiteStation {
  tools: SiteTool[];
}

/** 家戶 owner / admin 的 Kinio Station 逐台問 /station/tools；有工具（= 有回報機房資源）的才算。 */
export function useSiteRoom(): { stations: SiteRoomStation[]; loading: boolean } {
  const { homes, devices } = useScope();
  const candidates = useMemo(() => siteStations(homes, devices), [homes, devices]);
  const qs = useQueries({
    queries: candidates.map((s) => ({
      queryKey: ['siteroom', 'tools', s.homeId, s.aid],
      queryFn: () => siteApi.tools(s),
      staleTime: 5 * 60_000,
      retry: false,
    })),
  });
  const stations = candidates.flatMap((s, i) => {
    const tools = qs[i]?.data ?? [];
    return tools.length > 0 ? [{ ...s, tools }] : [];
  });
  return { stations, loading: qs.some((q) => q.isLoading) };
}

/** 左側選單的「機房」：至少一台有可分享工具。 */
export function useSiteRoomNav(): boolean {
  return useSiteRoom().stations.length > 0;
}
